import React, { Component } from 'react';
import dateFormat from 'dateformat';

import { listSignups, checkInSignup, markNoShow, SIGNUP_STATUS } from '../utils/openTablesApi';
import OpenTableChargeModal from './OpenTableChargeModal';
import { navigateTo } from '../utils/navigation';

// Inscripciones de una mesa abierta (molde: TableEventAdmissionsComponent).
// FR-009: nombre, contacto, lugares, estado y forma de pago. FR-051: check-in.
// FR-055/FR-056: no-show con confirmación (si estaba paga, la venta queda).
// FR-057 (enmienda For Test): en una confirmada SIN pago, "Llegó" abre el mini-modal de
// cobro (cobrar y validar, o dejar en cuenta — S-08d) y la fila ofrece "Cobrar" (S-08a).
// Inscripción de un socio que va solo: su único lugar es sin cargo (backend §4.8).
const nadaQueCobrar = (item) => item.memberSeat === true && Number(item.chargeableSeats) === 0;

class TableOpenTableSignupsComponent extends Component {

    constructor() {
        super();
        this.state = {
            statusFilter: 'all',
            data: [],
            loaded: false,
            disabled: false,
            chargeModal: null, // { item, mode: 'arrival' | 'charge' }
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = async () => {
        this.setState({ loaded: false });
        try {
            const data = await listSignups(this.props.openTableId);
            this.setState({ data: (data && data.signups) || [], loaded: true });
        } catch (error) {
            console.error('No se pudieron cargar las inscripciones:', error);
            alert(error.message || 'Error de conexión');
            this.setState({ data: [], loaded: true });
        }
    }

    // Recarga la lista y avisa a la página (el contador M/N del encabezado sale de la mesa).
    refresh = () => {
        this.fetchData();
        if (this.props.onChanged) this.props.onChanged();
    }

    onChangeStatus = (e) => {
        this.setState({ statusFilter: e.target.value });
    }

    visible = () => {
        const { data, statusFilter } = this.state;
        if (statusFilter === 'all') return data;
        return data.filter((s) => s.status === statusFilter);
    }

    checkIn = async (item) => {
        if (this.state.disabled) return;
        this.setState({ disabled: true });
        try {
            await checkInSignup(item.id);
            this.setState({ disabled: false });
            this.refresh();
        } catch (error) {
            console.error('No se pudo validar la llegada:', error);
            alert(error.message || 'Error de conexión');
            this.setState({ disabled: false });
        }
    }

    // "Llegó": una inscripción PAGA valida directo, sin re-cobro ni modal (FR-053). Una
    // confirmada sin pago pasa por el mini-modal de cobro (FR-057): cobrar y validar la
    // llegada, o dejar la entrada en la cuenta de la mesa (S-08d).
    arrive = (item) => {
        // Una inscripción que sólo trae al socio (lugar sin cargo, backend §4.8) no tiene nada
        // que cobrar: valida directo, como una paga.
        if (item.paid || nadaQueCobrar(item)) {
            this.checkIn(item);
            return;
        }
        this.setState({ chargeModal: { item, mode: 'arrival' } });
    }

    closeChargeModal = () => this.setState({ chargeModal: null });

    chargeModalDone = () => {
        this.setState({ chargeModal: null });
        this.refresh();
    }

    noShow = async (item) => {
        if (this.state.disabled) return;
        // FR-055: libera sólo el cupo. FR-056: una venta ya cobrada no se revierte — avisar
        // ANTES, porque después del click no hay vuelta atrás desde esta pantalla.
        const aviso = item.paid
            ? `¿Marcar como no presentada la inscripción de ${item.name || 'este anotado'}?\n\n`
                + `Se liberan sus ${item.seats} lugar(es). La inscripción estaba PAGA: la venta queda registrada, no hay devolución automática.`
            : `¿Marcar como no presentada la inscripción de ${item.name || 'este anotado'}?\n\nSe liberan sus ${item.seats} lugar(es).`;
        if (!window.confirm(aviso)) return;
        this.setState({ disabled: true });
        try {
            await markNoShow(item.id);
            this.setState({ disabled: false });
            this.refresh();
        } catch (error) {
            console.error('No se pudo marcar el no-show:', error);
            alert(error.message || 'Error de conexión');
            this.setState({ disabled: false });
        }
    }

    // Forma de pago (FR-009). El único cobro online de mesas abiertas es MercadoPago; en
    // modo libre el cover se cobra al llegar por la cuenta de mesa del salón.
    paymentCell = (item) => {
        // "Por devolver" va ANTES que "Paga": una inscripción paga cuya mesa se canceló (o
        // que canceló el dueño) sigue teniendo venta, pero lo operativo es la devolución.
        if (item.status === 'refund_pending') return { text: 'Por devolver', className: 'text-danger' };
        // En modo online el único cobro es MercadoPago; en modo libre la inscripción puede
        // quedar paga por el cobro presencial del salón (FR-057) — sin inventar el medio.
        if (item.paid) {
            return this.props.chargeMode === 'online'
                ? { text: 'Paga (MercadoPago)', className: 'text-success' }
                : { text: 'Paga', className: 'text-success' };
        }
        if (item.status === 'pending') return { text: 'Esperando pago online', className: 'text-warning' };
        if (item.status === 'confirmed' && this.props.chargeMode === 'libre') {
            return { text: 'Se cobra al llegar', className: 'text-muted' };
        }
        return { text: 'Sin pago', className: 'text-muted' };
    }

    statusCell = (item) => {
        const st = SIGNUP_STATUS[item.status] || { label: item.status, badge: 'badge-light' };
        return (
            <span>
                <span className={`badge ${st.badge}`}>{st.label}</span>
                {item.checkedInAt && (
                    <small className="text-success d-block">Llegó {dateFormat(item.checkedInAt, 'HH:MM')}</small>
                )}
            </span>
        );
    }

    render() {
        const visibles = this.visible();
        return (
            <div className="card card-small mb-4">
                <div className="card-body p-0">
                    <div className="p-3 border-bottom">
                        <label className="mb-0">Estado:&nbsp;
                            <select className="custom-select" style={{ width: 'auto', display: 'inline-block' }} value={this.state.statusFilter} onChange={this.onChangeStatus}>
                                <option value="all">Todas</option>
                                <option value="confirmed">{SIGNUP_STATUS.confirmed.label}</option>
                                <option value="pending">{SIGNUP_STATUS.pending.label}</option>
                                <option value="refund_pending">{SIGNUP_STATUS.refund_pending.label}</option>
                                <option value="no_show">{SIGNUP_STATUS.no_show.label}</option>
                                <option value="cancelled">{SIGNUP_STATUS.cancelled.label}</option>
                                <option value="expired">{SIGNUP_STATUS.expired.label}</option>
                            </select>
                        </label>
                    </div>
                    <table className="table mb-0">
                        <thead className="bg-light">
                            <tr>
                                <th>Nombre</th>
                                <th>Mail</th>
                                <th>Celular</th>
                                <th className="text-center">Lugares</th>
                                <th>Anotado</th>
                                <th>Pago</th>
                                <th>Estado</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {!this.state.loaded && (
                                <tr><td colSpan="8" className="text-center">Cargando…</td></tr>
                            )}
                            {this.state.loaded && visibles.length === 0 && (
                                <tr><td colSpan="8" className="text-center text-muted">No hay inscripciones para mostrar.</td></tr>
                            )}
                            {this.state.loaded && visibles.map((item) => (
                                <tr key={item.id}>
                                    <td>
                                        {/* El nombre lleva al detalle del cliente: ahí está el interruptor
                                            que lo habilita como anfitrión (spec-mesa-abierta FR-070), y los
                                            habituales a habilitar son justamente los que aparecen acá. */}
                                        {item.accountId ? (
                                            <a
                                                href={`/clientDetail?accountId=${encodeURIComponent(item.accountId)}`}
                                                onClick={(e) => { e.preventDefault(); navigateTo(`/clientDetail?accountId=${encodeURIComponent(item.accountId)}`); }}
                                            >
                                                {item.name || 'Ver cliente'}
                                            </a>
                                        ) : (item.name || '—')}
                                        {/* FR-081: la inscripción de quien abrió la mesa. */}
                                        {item.isHost && <span className="badge badge-info ml-2">Anfitrión</span>}
                                    </td>
                                    <td>{item.email || '—'}</td>
                                    <td>{item.phone || '—'}</td>
                                    <td className="text-center">
                                        {item.seats}
                                        {item.memberSeat && <small className="text-success d-block">1 socio sin cargo</small>}
                                    </td>
                                    <td>{item.createdAt ? dateFormat(item.createdAt, 'dd/mm/yyyy HH:MM') : '—'}</td>
                                    <td className={this.paymentCell(item).className}>{this.paymentCell(item).text}</td>
                                    <td>{this.statusCell(item)}</td>
                                    <td className="text-right text-nowrap">
                                        {/* Check-in sólo para confirmadas que todavía no llegaron. Paga →
                                            directo (FR-053); sin pago → mini-modal de cobro (FR-057), con
                                            "dejar en cuenta" como el flujo de siempre (FR-052, S-08d). */}
                                        {item.status === 'confirmed' && !item.checkedInAt && (
                                            <button type="button" className="btn btn-sm btn-accent" disabled={this.state.disabled} onClick={() => this.arrive(item)}>
                                                Llegó
                                            </button>
                                        )}
                                        {/* S-08a: cobrar sin validar la llegada (el check-in posterior no re-cobra). */}
                                        {item.status === 'confirmed' && !item.checkedInAt && !item.paid && !nadaQueCobrar(item) && (
                                            <button type="button" className="btn btn-sm btn-white ml-2" disabled={this.state.disabled} onClick={() => this.setState({ chargeModal: { item, mode: 'charge' } })}>
                                                Cobrar
                                            </button>
                                        )}
                                        {item.status === 'confirmed' && !item.checkedInAt && (
                                            <button type="button" className="btn btn-sm btn-outline-danger ml-2" disabled={this.state.disabled} onClick={() => this.noShow(item)}>
                                                No vino
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.state.chargeModal && (
                    <OpenTableChargeModal
                        show
                        signup={this.state.chargeModal.item}
                        unitPrice={this.props.unitPrice}
                        mode={this.state.chargeModal.mode}
                        onCheckIn={() => checkInSignup(this.state.chargeModal.item.id)}
                        onDone={this.chargeModalDone}
                        onRefresh={this.refresh}
                        onClose={this.closeChargeModal}
                    />
                )}
            </div>
        );
    }
}

export default TableOpenTableSignupsComponent;
